module.exports = __webpack_public_path__ + "static/img/20.694bf67.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/20.png
// module id = JvGD
// module chunks = 0